import React from "react";
import "./SearchBar.css";

function SearchBar({ label, placeholder, onChange, onSubmit, altColours, className, handleSearch, ...props }) {
  return (
    <div className={"d-flex" + (className || "")}>
      {label ?
        <div className="d-flex float-left flex-col justify-center search-label">
          {label}
        </div>
        : null
      }

      <div className={"d-flex float-right " + (altColours ? "search-bar-2" : "search-bar-1")}>
        <form onSubmit={onSubmit} className="search-bar-form">
          <input
            className="search-bar-input"
            type="text"
            placeholder={placeholder || "Search..."}
            onChange={
              onChange ?
                (e) => onChange(e)
                : () => { }
            }
            {...props}
          />

          <button type="submit" className="search-bar-icon" disabled={!onSubmit}>
            <i className="mdi mdi-magnify filter-search-icon" onClick={handleSearch} />
          </button>
        </form>
      </div>
    </div>
  )
}

export default SearchBar;
